package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Pager position dots: the active page renders as a wider primary pill, the rest as neutral dots.
 * Width/color animate on page change. Purely decorative — callers put page semantics (e.g. a
 * localized "step x of y" contentDescription) on the pager itself, not here.
 */
@Composable
fun AppPageIndicator(
    pageCount: Int,
    currentPage: Int,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        repeat(pageCount) { index ->
            val active = index == currentPage
            val width by animateDpAsState(
                if (active) AppTheme.sizes.pageIndicatorActiveWidth else AppTheme.sizes.pageIndicatorDot,
            )
            val color by animateColorAsState(
                if (active) AppTheme.colors.primary else AppTheme.colors.surfaceContainer,
            )
            androidx.compose.foundation.layout.Box(
                modifier = Modifier
                    .width(width)
                    .height(AppTheme.sizes.pageIndicatorDot)
                    .background(color, AppTheme.shapes.pill),
            )
        }
    }
}

@Preview
@Composable
private fun AppPageIndicatorPreview() {
    AppTheme {
        AppPageIndicator(pageCount = 3, currentPage = 0)
    }
}
